<template>
  <div class="app-foot-vue">
    <transition name="foot-page-switch" mode="out-in">
      <router-view :parentApi="parentApi" />
    </transition>
    <div class="app-foot-placeholder" v-if="showFoot">
      <div class="app-foot-bar">
        <div class="foot-item" v-for="(item, index) in footList" :key="index">
          <div @click="clickFootItem(item, index)" class="foot-item-real">
            <img :src="index === active ? item.activeImg : item.img" />
            <span :class="index === active ? 'activeSpan' : ''">{{
              item.title
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    let that = this;
    return {
      showFoot: true,
      footList: [
        {
          name: "首页",
          title: "首页",
          img: require("@/assets/foot/home.png"),
          activeImg: require("@/assets/foot/home-active.png"),
          url: "/",
        },
        {
          name: "分类",
          title: "分类",
          img: require("@/assets/foot/class.png"),
          activeImg: require("@/assets/foot/class-active.png"),
          url: "/classify",
        },
        {
          name: "购物车",
          title: "购物车",
          img: require("@/assets/foot/gouwuche_hui@2x.png"),
          activeImg: require("@/assets/foot/gouwuche_hui.png"),
          url: "/car",
        },
        {
          name: "我的",
          title: "我的",
          img: require("@/assets/foot/mine_hui@2x.png"),
          activeImg: require("@/assets/foot/mine_hui.png"),
          url: "/my",
        },
      ],
      active: 0,
      parentApi: {
        changeFootStatus(show) {
          that.showFoot = !!show;
        },
      },
    };
  },
  methods: {
    clickFootItem(item, index) {
      if (this.$route.path === item.url) {
        return false;
      }
      this.active = index;
      this.$router.replace(item.url);
    },
    initActive(path) {
      this.showFoot = true;
      path = path || this.$route.path;
      for (let i = 0; i < this.footList.length; i++) {
        if (this.footList[i].url === path) {
          this.active = i;
        }
      }
    },
  },
  components: {},
  pass: true,
  created() {
    this.initActive();
  },
  beforeRouteUpdate(to, from, next) {
    this.initActive(to.path);
    next();
  },
};
</script>

<style scoped>
.foot-page-switch-enter-active,
.foot-page-switch-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.foot-page-switch-enter {
  opacity: 0;
}

.foot-page-switch-leave-to {
  opacity: 0;
}

.app-foot-vue {
  position: relative;
  height: 100vh;
  width: 100%;
  /* overflow: auto; */
}

.app-foot-bar {
  position: fixed;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
}

.app-foot-bar,
.app-foot-placeholder {
  height: 50px;
}

.foot-item,
.foot-item-real {
  display: flex;
  justify-content: center;
  align-items: center;
}

.foot-item {
  height: 100%;
  flex: 1;
}

.foot-item-real {
  height: 100%;
  font-size: 12px;
  flex-direction: column;
  padding: 0 10px;
}

.foot-item-real > img {
  width: 24px;
  height: 24px;
}
</style>